// components/NetworkStatus.js
import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaWifi } from "react-icons/fa"; // Modern icon

const NetworkStatus = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);

    return (
        <AnimatePresence>
            {!isOnline && (
                <motion.div
                    initial={{ y: -100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -100, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 300, damping: 25 }}
                    className="check-internet"
                    style={{
                        position: "fixed",
                        left: "35vw", // 👈 force center of the screen
                        transform: "translateX(-50%)", // 👈 shift back by half of its width
                        backgroundColor: "#ff4d4f",
                        color: "#fff",
                        padding: "14px 24px",
                        borderRadius: "12px",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                        fontWeight: 500,
                        zIndex: 10000,
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        fontSize: "16px",
                        maxWidth: "90vw",
                    }}

                >
                    <FaWifi style={{ fontSize: "18px" }} />
                    No internet connection. Please check your network !
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default NetworkStatus;
